// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='Chart'] {\r\n  font-family: sans-serif;\r\n  text-align: center;\r\n}\r\n  [name='Chart'] svg {\r\n    width: unset;\r\n  }\r\n", ""]);
// Exports
module.exports = exports;
